<template>
  <div class="contact-us-container">
    <div class="message-form">
      <h2 class="form-title">在线留言</h2>
      <p class="form-subtitle">请在线提交您的信息和咨询问题，我们会及时与您联系，竭诚为您服务</p>
      
      <div class="form-divider"></div>
      
      <el-form :model="formData" :rules="rules" ref="messageForm" class="message-form-content">
        <el-form-item prop="companyName">
          <div class="form-item-wrapper">
            <label class="form-label">
              公司名称<span class="required">*</span>
            </label>
            <el-input 
              v-model="formData.companyName" 
              placeholder="请输入公司名称"
              class="form-input"
            ></el-input>
          </div>
        </el-form-item>
        
        <el-form-item prop="contactName">
          <div class="form-item-wrapper">
            <label class="form-label">联系人</label>
            <el-input 
              v-model="formData.contactName" 
              placeholder="请输入您的姓名"
              class="form-input"
            ></el-input>
          </div>
        </el-form-item>
        
        <el-form-item prop="email">
          <div class="form-item-wrapper">
            <label class="form-label">Email</label>
            <el-input 
              v-model="formData.email" 
              placeholder="请输入EMAIL"
              class="form-input"
            ></el-input>
          </div>
        </el-form-item>
        
        <el-form-item prop="phone">
          <div class="form-item-wrapper">
            <label class="form-label">
              联系电话<span class="required">*</span>
            </label>
            <el-input 
              v-model="formData.phone" 
              placeholder="请输入联系电话"
              class="form-input"
              maxlength="11"
            ></el-input>
          </div>
        </el-form-item>
        
        <el-form-item prop="message">
          <div class="form-item-wrapper">
            <label class="form-label">您的需求</label>
            <el-input 
              type="textarea"
              v-model="formData.message" 
              placeholder="请输入您的需求"
              :rows="6"
              class="form-textarea"
            ></el-input>
          </div>
        </el-form-item>
        
        <el-form-item prop="captcha">
          <div class="form-item-wrapper captcha-wrapper">
            <label class="form-label">
              验证码<span class="required">*</span>
            </label>
            <div class="captcha-input-group">
              <el-input 
                v-model="formData.captcha" 
                placeholder="请输入验证码"
                class="form-input captcha-input"
              ></el-input>
              <div class="captcha-image" @click="refreshCaptcha">
                <img :src="codeUrl + '&id=' + formData.codeId" alt="验证码" />
              </div>
            </div>
          </div>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" class="submit-btn" @click="submitForm">
            立即提交
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import feedback from "@/api/feedback"
import publics from "@/api/public"
import { uuid } from "@/utils/random"

const messageForm = ref(null)
const codeUrl = ref('')

const formData = reactive({
  companyName: '',
  contactName: '',
  email: '',
  phone: '',
  message: '',
  captcha: '',
  codeId: uuid()
})

const rules = {
  companyName: [
    { required: true, message: '请输入公司名称', trigger: 'blur' }
  ],
  phone: [
    { required: true, message: '请输入联系电话', trigger: 'blur' },
    { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的11位手机号', trigger: 'blur' }
  ],
  captcha: [
    { required: true, message: '请输入验证码', trigger: 'blur' }
  ]
}

const refreshCaptcha = () => {
  formData.codeId = uuid()
}

const submitForm = async () => {
  messageForm.value.validate(async (valid) => {
    if (valid) {
      try {
        await feedback.add(formData)
        ElMessage.success('提交成功')
        // 重置表单
        messageForm.value.resetFields()
        // 刷新验证码
        formData.codeId = uuid()
      } catch (error) {
        ElMessage.error('提交失败，请稍后重试')
        // 刷新验证码
        formData.codeId = uuid()
      }
    } else {
      ElMessage.error('请填写必填项')
      return false
    }
  })
}

onMounted(() => {
  publics.captcha().then(res => {
    codeUrl.value = res
  })
})
</script>

<style scoped>
.contact-us-container {
  min-height: 100vh;
  padding: 40px 20px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.message-form {
  width: 100%;
  max-width: 1000px;
  background: #ffffff;
  padding: 40px 50px 50px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.form-title {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  margin: 0 0 15px 0;
}

.form-subtitle {
  font-size: 14px;
  color: #666;
  margin: 0 0 20px 0;
  line-height: 1.6;
}

.form-divider {
  height: 3px;
  background: linear-gradient(to right, #00bcd4 0%, #00bcd4 60%, transparent 60%);
  margin-bottom: 30px;
}

.message-form-content {
  margin-top: 30px;
}

.form-item-wrapper {
  display: flex;
  align-items: flex-start;
  width: 100%;
}

.form-label {
  min-width: 100px;
  font-size: 15px;
  color: #333;
  padding-top: 10px;
  text-align: left;
}

.required {
  color: #f56c6c;
  margin-left: 2px;
}

.form-input {
  flex: 1;
}

.form-input :deep(.el-input__inner) {
  height: 45px;
  line-height: 45px;
  border: 1px solid #dcdfe6;
  border-radius: 0;
  font-size: 14px;
  padding: 0 15px;
  background-color: #fff;
  transition: border-color 0.2s;
}

.form-input :deep(.el-input__inner:hover) {
  border-color: #c0c4cc;
}

.form-input :deep(.el-input__inner:focus) {
  border-color: #00bcd4;
  outline: none;
}

.form-input :deep(.el-input__inner::placeholder) {
  color: #c0c4cc;
  font-size: 14px;
}

.form-textarea {
  flex: 1;
}

.form-textarea :deep(.el-textarea__inner) {
  border: 1px solid #dcdfe6;
  border-radius: 0;
  font-size: 14px;
  padding: 10px 15px;
  font-family: inherit;
  background-color: #fff;
  transition: border-color 0.2s;
  resize: none;
}

.form-textarea :deep(.el-textarea__inner:hover) {
  border-color: #c0c4cc;
}

.form-textarea :deep(.el-textarea__inner:focus) {
  border-color: #00bcd4;
  outline: none;
}

.form-textarea :deep(.el-textarea__inner::placeholder) {
  color: #c0c4cc;
  font-size: 14px;
}

.captcha-wrapper .form-item-wrapper {
  align-items: center;
}

.captcha-input-group {
  flex: 1;
  display: flex;
  gap: 15px;
  align-items: center;
}

.captcha-input {
  flex: 1;
}

.captcha-image {
  width: 120px;
  height: 45px;
  cursor: pointer;
  border: 1px solid #dcdfe6;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
  transition: border-color 0.2s;
}

.captcha-image:hover {
  border-color: #c0c4cc;
}

.captcha-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.submit-btn {
  width: 350px;
  height: 45px;
  background: #00bcd4;
  border: none;
  border-radius: 0;
  font-size: 16px;
  font-weight: normal;
  margin-left: 100px;
  margin-top: 10px;
}

.submit-btn:hover {
  background: #00acc1;
}

:deep(.el-form-item) {
  margin-bottom: 25px;
  border: none;
}

:deep(.el-form-item__content) {
  line-height: normal;
  border: none;
}

:deep(.el-form-item__error) {
  padding-left: 100px;
}

:deep(.el-input),
:deep(.el-textarea) {
  border: none;
}

:deep(.el-input__wrapper) {
  box-shadow: none;
  padding: 0;
}

@media screen and (max-width: 768px) {
  .contact-us-container {
    padding: 20px 10px;
  }

  .message-form {
    padding: 20px 15px 30px;
  }

  .form-title {
    font-size: 22px;
    margin-bottom: 10px;
  }

  .form-subtitle {
    font-size: 13px;
    margin-bottom: 15px;
  }

  .form-divider {
    margin-bottom: 20px;
  }

  .message-form-content {
    margin-top: 20px;
  }

  .form-item-wrapper {
    flex-direction: column;
    align-items: flex-start;
  }

  .form-label {
    min-width: auto;
    width: 100%;
    padding-top: 0;
    padding-bottom: 8px;
    font-size: 14px;
  }

  .form-input,
  .form-textarea {
    width: 100%;
  }

  .captcha-wrapper .form-item-wrapper {
    flex-direction: column;
  }

  .captcha-input-group {
    width: 100%;
    flex-direction: row;
  }

  .captcha-input {
    flex: 1;
  }

  .captcha-image {
    width: 100px;
    height: 45px;
  }

  .submit-btn {
    width: 100%;
    margin-left: 0;
    margin-top: 5px;
  }

  :deep(.el-form-item) {
    margin-bottom: 20px;
  }

  :deep(.el-form-item__error) {
    padding-left: 0;
  }
}
</style>
